//
// The constants for the GraphQL client on the web

export const IS_PROD =
  process.env.NODE_ENV === 'production' && !process.env.FORCE_DEV;
// export const ENABLE_SSL = process.env.ENABLE_SSL == 'enable';
const ENABLE_SSL = true;
// In production the API is at the same URL, in development it's at a different port
export const API_URI = IS_PROD ? '/api' : 'http://localhost:3001/api';
export const WS_URI = IS_PROD
  ? `${ENABLE_SSL ? 'wss' : 'ws'}://${window.location.host}/websocket`
  : 'ws://localhost:3001/websocket';
export const REST_URL = IS_PROD
  ? '/rest/common'
  : 'http://localhost:3001/rest/common';
